import Admin from "../Admin";
import React from "react";
import CardAdminAccountTypeList from "../../../Component/Card/Admin/AccountType/CardAdminAccountTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AccountTypeList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminAccountTypeList />
        );
    }

    /**
     * Render the header.
     */
    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/accountType"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Account Types" buttons={buttons} />
        );
    }
}
